export default "__VITE_ASSET__DNbBVht3__"